import React, { useState } from "react";
import Logo from "../../assets/logos/banner.png";
import axios from "axios";
import cookie from "js-cookie";
import { clearCookies } from "globalResources/helpers";
import Input from "globalComponents/Input";
import styled from "styled-components";
import { Button } from "semantic-ui-react";
import { getTheme } from "../../Theme.js";
import { errorHandler } from "globalResources/util";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { TextButton } from "globalComponents";
const theme = getTheme();

const Main = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  min-height: 100vh;
  width: 100%;
`;
const Banner = styled.img`
  width: 100%;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${theme.MAIN_COLOR};
  height: 100vh;
  min-width: 50vh;
  gap: 10px;
  width: 100%;
  align-items: center;
  padding: 50px 18px 10px 18px;
`;

const Bulletin = styled.div`
  background: ${theme.MANILLA};
  color: ${theme.MESSAGE_TEXT};
  border-radius: 10px;
  padding: 16px;
`;

const Title = styled.h2``;

const Paragraph = styled.p`
  font-size: 16px;
  font-weight: 500;
`;

const ListItem = styled.li`
  font-size: 16px;
  font-weight: 500;
`;

const Error = styled.h2`
  color: ${theme.NEGATIVE};
`;

const Login = () => {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const submit = () => {
    if (!email) setError("Email is required");
    else {
      setLoading(true);
      setError("");
      axios
        .post(`${process.env.REACT_APP_API_URL}/login`, {
          email: email.includes("@") ? email : null,
          phone: email,
          password: password,
        })
        .then(async (res) => {
          if (res.data.token) {
            await clearCookies();
            //set token
            cookie.set("token", res.data.token, { expires: 0.9 }); //set cookie to expire in one day
            cookie.set("type", "user", { expires: 0.9 });
            cookie.set(
              "name",
              res.data.user.firstName + " " + res.data.user.lastName,
            );
            cookie.set("id", res.data.user._id);
            axios.defaults.headers.common["Authorization"] = res.data.token;
            window.location.href = "dashboard";
          } else {
            window.alert(
              `Check your ${
                email.includes("@") ? "email" : "phone"
              } for the sign in link`,
            );
          }
        })
        .catch((err) => {
          const { message } = errorHandler(err);
          setError("Login Failed Try Again");
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <Main>
      <LoginContainer>
        <Banner src={Logo} />
        <Input
          label="Email or Phone"
          name="username"
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => e.key === "Tab" && setPassword("")}
        />
        {password !== undefined && (
          <>
            <Input
              label="Password"
              name="password"
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && submit()}
            />
            <Paragraph>
              Forgot your password or dont have one yet?
              <TextButton onClick={submit}> Reset it here</TextButton>
            </Paragraph>
          </>
        )}
        <Button
          loading={loading}
          color="blue"
          content={password === undefined ? "Get Sign in Link" : "Login"}
          onClick={submit}
        />
        {password === undefined && (
          <Button
            color="blue"
            content="Use Password"
            onClick={() => setPassword("")}
          />
        )}
        <Paragraph>
          Dont have an account? <a href="/onboarding/root">Create one here</a>
        </Paragraph>
        <Error>{error}</Error>
        {cookie.get("timestationToken") && (
          <Button
            color="green"
            style={{ marginTop: "auto" }}
            onClick={() => history.push("/timestation")}
          >
            Go To Timestation
          </Button>
        )}

        <Paragraph style={{ marginTop: "auto", textAlign: "center" }}>
          © {moment().format("yyyy")} Time Card Solutions,LLC{" "}
        </Paragraph>
      </LoginContainer>
      <InfoContainer>
        <Bulletin>
          <Title style={{ textAlign: "center", fontSize: "28px" }}>
            Update Bulletin
          </Title>
          <Title>Infrastructure Update!</Title>
          <Paragraph>
            TCS has recently undergone an infrastructure update to improve
            system performance and reliability!
          </Paragraph>

          <Paragraph>
            We have moved to a more scalable and robust infrastructure to better
            serve our users and reduce interruptions across all connected
            features of our application.
          </Paragraph>

          <Paragraph>
            Several bugs have been addressed and resolved along with the total
            update of the core of our application.
          </Paragraph>

          <Paragraph>
            If you have any issues please contact us at{" "}
            <a href="mailto:geverly@timecardsolutions.com">
              support@timecardsolutions.com
            </a>
          </Paragraph>
          <Title>Coming Soon</Title>
          <ul>
            <ListItem>Enhanced user account management</ListItem>
            <ListItem>Improved Employee Analytics</ListItem>
            <ListItem>Enhanced Client experience </ListItem>
            <ListItem>Mobile App Release</ListItem>
          </ul>
          <Title>Have suggestions for us?</Title>
          <Paragraph>
            Contact us with your feature requests at{" "}
            <a href="mailto:geverly@timecardsolutions.com">
              support@timecardsolutions.com
            </a>
            , or use the Bug Report feature after loggin into TCS.
          </Paragraph>
        </Bulletin>
      </InfoContainer>
    </Main>
  );
};
export default Login;
